<template>
  <div class="w-full flex items-center justify-center">
    <value-or-variable-with-label label='Alpha' toggle-position='col' :value='value'>
      <template #default='{}'>
        <numberer class="flex-1" :value='value' @change="onInput" :step='0.1' />
      </template>
    </value-or-variable-with-label>
  </div>
</template>
<script>
import Numberer from '@ui/atoms/Numberer.vue';
import ValueOrVariableWithLabel from '@ui/molecules/ValueOrVariableWithLabel.vue';
export default {
  props:{
    value:{
      type:Number,
      required:true
    }
  },
  methods: {
    onInput(nv, ov) {
      this.$emit("input", nv, ov);
      this.$emit("change", nv, ov);
    }
  },
  data() {
    return {
    }
  },
  components:{
    Numberer,
    ValueOrVariableWithLabel
  }
}
</script>
